import React from 'react';
import { motion } from 'framer-motion';

export default function MenuItem({ name, price }) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="group relative"
    >
      <div className="flex justify-between items-baseline p-4 bg-white/80 backdrop-blur-sm rounded-lg hover:bg-white transition-colors duration-300">
        <div className="flex-1">
          <span className="text-gray-900 group-hover:text-red-700 transition-colors font-medium">
            {name}
          </span>
          <div className="mt-1 border-b border-dotted border-gray-300" />
        </div>
        <span className="ml-4 text-red-700 font-bold whitespace-nowrap">
          {price} kr
        </span>
      </div>
      
      {/* Vintage corner decorations */}
      <div className="absolute -top-1 -left-1 w-3 h-3 border-t-2 border-l-2 border-red-700/30 rounded-tl" />
      <div className="absolute -top-1 -right-1 w-3 h-3 border-t-2 border-r-2 border-red-700/30 rounded-tr" />
      <div className="absolute -bottom-1 -left-1 w-3 h-3 border-b-2 border-l-2 border-red-700/30 rounded-bl" />
      <div className="absolute -bottom-1 -right-1 w-3 h-3 border-b-2 border-r-2 border-red-700/30 rounded-br" />
    </motion.div>
  );
}